import React, { useEffect, useMemo, useRef } from "react";
import { Link } from "react-router-dom";

type Breadcrumb = { text: string; to: string };
type Breadcrumbs = Array<Breadcrumb>;

interface BreadcrumbsProps {
  links: Breadcrumbs;
  classname?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ links, classname = "" }) => {
  const divRef = useRef<HTMLHeadingElement>(null);

  const breadcrumbs = useMemo(
    () =>
      links
        .reduce(
          (r: Breadcrumbs, a: Breadcrumb) =>
            r.concat(a, { text: "->", to: "" }),
          []
        )
        .slice(0, 2 * links.length - 1),
    [links]
  );

  useEffect(() => {
    setTimeout(() => {
      if (divRef.current) {
        divRef.current.scrollTo({
          left: divRef.current.offsetWidth,
          behavior: "smooth",
        });
      }
    }, 1000);
  }, []);

  return links.length > 0 ? (
    <div
      className={`flex flex-row items-center w-full mb-2 text-sm text-subtitle leading-none overflow-x-scroll no-scrollbar ${classname}`}
      ref={divRef}
    >
      {breadcrumbs.map((breadcrumb, i) =>
        breadcrumb.text === "->" ? (
          <i key={i} className="material-icons mx-2">
            arrow_forward
          </i>
        ) : (
          <Link
            key={i}
            className={`font-medium rounded-lg capitalize whitespace-no-wrap ${
              i === 2 * links.length - 2 && "text-text"
            } hover:text-orange`}
            to={breadcrumb.to}
          >
            {breadcrumb.text}
          </Link>
        )
      )}
    </div>
  ) : null;
};

export default Breadcrumbs;
